import "./style.scss";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {useEffect} from "react";

function Interval({interval, handler}) {
    useEffect(() => {
        if (!interval) {
            handler(2);
        }
    });
    const handleChange = (event) => {
        handler(event.target.value);
    };

    return <>
        <FormControl className="calc-radio-wrapper">
            <RadioGroup
                className="calc-radio-group"
                row
                name="calc-interval"
                value={interval}
                onChange={handleChange}
            >
                <FormControlLabel className="calc-radio-item" value="1" control={<Radio />} label="Monthly" />
                <FormControlLabel className="calc-radio-item" value="2" control={<Radio />} label="Fortnightly" />
                <FormControlLabel className="calc-radio-item" value="3" control={<Radio />} label="Weekly" />
            </RadioGroup>
        </FormControl>
    </>;
}

export default Interval;